<template>
  <div></div>
</template>
<script>
import apis from '@/utils/apis';

export default {
  created() {
    this.$getJSON(apis.App, { appCode: 'customer-portal' }).then((res) => {
      const menu = res.data || [];
      const firstMenu = menu[0] || {};
      const firstMenuItem = firstMenu.children && firstMenu.children[0] ? firstMenu.children[0] : firstMenu;
      this.jump(firstMenuItem.loadRes);
    });
  },
};
</script>
